import React from 'react';
import Tooltip from '../../../shared/Tooltip';
import Color from '../../../../enums/color';
import FlexContainer from '../../../shared/FlexContainer';
import styled from 'styled-components';
import ContentHandler from '../../../shared/ContentHandler';
import { getSimplifiedColorCode } from '../../../../helpers/color';
import classnames from 'classnames';
const StyledTooltip = styled(Tooltip) `
  z-index: 1;

  &.colorTheme-${getSimplifiedColorCode(Color.White)} {
    .ant-tooltip-inner {
      border: 1px solid ${Color.Black};
      color: ${Color.Black};
      min-width: max-content;
    }

    .ant-tooltip-arrow-content {
      border: 1px solid ${Color.Black};
    }
  }

  &.colorTheme-${getSimplifiedColorCode(Color.GoldenTainoi)} {
    .ant-tooltip-inner {
      border: 1px solid ${Color.GoldenTainoi};
      color: ${Color.White};
      min-width: max-content;
    }

    .ant-tooltip-arrow-content {
      border: 1px solid ${Color.GoldenTainoi};
    }
  }
`;
const TooltipContainer = styled(FlexContainer) `
  padding-left: 12px;
  align-items: center;
  justify-content: flex-start;

  & div {
    display: flex;
  }
`;
const Title = styled.div `
  white-space: pre-wrap;
  font-weight: normal;
`;
const InfoTooltip = ({ text, colorTheme = Color.White, getPopupContainer, children }) => (<ContentHandler shouldDisplayContent={text !== ''}>
    <TooltipContainer>
      <StyledTooltip title={<Title>{text}</Title>} placement='right' color={colorTheme} className={classnames([`colorTheme-${getSimplifiedColorCode(colorTheme)}`])} getPopupContainer={getPopupContainer}>
        {children}
      </StyledTooltip>
    </TooltipContainer>
  </ContentHandler>);
export default InfoTooltip;
